import React from "react";

function MicOnIcon(props) {
  return (    
    <svg xmlns="http://www.w3.org/2000/svg" width="13.102" height="24" viewBox="0 0 13.102 24">
  <g id="Group_18742" data-name="Group 18742" transform="translate(-524.166 -726.859)">
    <g id="Group_18741" data-name="Group 18741" transform="translate(523.146 726.859)">
      <path id="Subtraction_193" data-name="Subtraction 193" d="M10.808,3.319v8.724c0,4.348-6.476,4.348-6.476,0V3.319A3.239,3.239,0,1,1,10.808,3.319ZM8.323,18.72v3.727h2.41a.778.778,0,0,1,0,1.553H4.408a.778.778,0,0,1,0-1.553h2.41V18.72a6.65,6.65,0,0,1-5.8-6.677v-.854a.753.753,0,1,1,1.506,0v.854a5.176,5.176,0,0,0,5.045,5.2,5.176,5.176,0,0,0,5.045-5.2v-.854a.753.753,0,1,1,1.506,0v.854A6.65,6.65,0,0,1,8.323,18.72Z" fill="#f45e29" fill-rule="evenodd"/>
    </g>
  </g>
</svg>

  );
}

export default MicOnIcon;
